import { Component } from "@angular/core";
import { MultiUserFormSetupService } from "@main/formio/multi-user-form/services/multi-user-form-setup.service";

@Component({
    selector: "multi-user-form-setup",
    templateUrl: "./multi-user-form-setup.component.html"
})
export class MultiUserFormSetupComponent {
    constructor(protected multiUserFormSetupService: MultiUserFormSetupService) {
    }
}